<template>
	<div class="park">
		<div class="header">
			<div class="left">
				<div class="name">常德市</div>
				<div class="info">
					<span>占地面积：1.82万平方公里</span>
					<span>人口总数：599.29万人</span>
				</div>
			</div>
			<div class="right">
				<div class="number">
					<span>10</span>
					<span>园区数量</span>
				</div>
				<div class="icon" @click="pushWithQuery(1)">
					<img src="../assets/images/project_map.png" />
					<!-- <span>分布图</span> -->
				</div>
			</div>
		</div>
		<div class="main">
			<div class="list-box">
				<div class="list" v-for="(item, index) in listData" :key="index">
					<div class="top" @click="toParkDetail('parkIntro', item.parkInformationMarksId , item.marksName)">
						<div class="left">
							<img :src="baseUrl+item.parkInformationImg">
						</div>
						<div class="right">
							<div class="title">{{ item.marksName }}</div>
							<div class="info">
								<span class="level" v-if="item.parkInformationLevel==1">国家级</span>
								<span class="level" v-if="item.parkInformationLevel==2">省级</span>
								
								<span class="type" v-if="item.parkInformationType==1">高新技术产业</span>
								<span class="type" v-if="item.parkInformationType==2">工业园区</span>
								<span class="type" v-if="item.parkInformationType==3">开发区</span>
								<span class="type" v-if="item.parkInformationType==4">产业开发区</span>
							</div>
							<div class="text">
								<span class="land-area"><b>面积：</b>{{ item.parkInformationArea }}</span>
							</div>
						</div>
					</div>
					<div class="bottom">
						<span class="position"><b>位置：</b>{{ item.parkInformationPosition }}</span>
						<span class="icon">
							<!-- <img class="map" src="../assets/images/map.png" /> -->
							<img class="tel" src="../assets/images/phone.png" @click="callPhone(item.parkInformationInvestmentConsult.substring(0,item.parkInformationInvestmentConsult.lastIndexOf('#')))" />
						</span>
					</div>
				</div>
				<!-- 				<div class="emptStyle">
					暂无相关数据
				</div> -->
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	import {
		useRouter
	} from 'vue-router'
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import {
		getParkList
	} from '../axios/api.js';
	export default defineComponent({
		components: {
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			let baseUrl = 'https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi';
			const listData = ref('');
			(function getListData() {
				getParkList('/cdMapApi/api/park/list', {

				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						listData.value = data
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();

			const router = useRouter();
			// 地图跳转
			function pushWithQuery(menuId) {
				sessionStorage.setItem('curMeunId', menuId);
				router.push({
					name: 'mapView',
				});
			}
			function toMapPosition() {
				router.push({
					name: 'mapPosition',
				});
			}
			// 详情
			function toParkDetail(name, query, title) {
				router.push({
					name: name,
					query: {
						query,
						title
					},
				})
			}
			
			function callPhone(phoneNumber) {
				// console.log('电话：',phoneNumber);
				window.location.href = 'tel:' + phoneNumber
			}

			return {
				baseUrl,
				getParkList,
				listData,
				toMapPosition,
				pushWithQuery,
				toParkDetail,
				callPhone
			}
		}
	})
</script>

<style lang="scss" scoped>
	.park {
		background-color: #f8f8f8;
		background-image: url(../assets/banner/project_banner.jpg);
		background-repeat: no-repeat;
		background-position: center top;
		background-size: 100%;

		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px;

			.left {
				width: 60%;

				.name {
					padding: 10px;
					color: #fff;
					font-size: 24px;
					font-weight: bold;
				}

				.info {
					padding: 0px 10px;

					span {
						display: block;
						font-size: 14px;
						color: #fff;
					}
				}
			}

			.right {
				width: 40%;
				display: flex;
				justify-content: right;
				align-items: center;
				padding-top: 20px;
				padding-right: 10px;

				.number {
					span {
						display: block;
						font-size: 16px;
						font-weight: 600;
						color: #fff;
						text-align: center;
					}
				}

				.icon {
					width: 50px;
					height: 50px;

					img {
						width: 50px;
					}
				}
			}
		}

		.main {
			margin: 0px 10px;

			.list-box {
				background: #fff;
				padding: 5px 0px 20px 0px;
				border-radius: 5px 5px 0px 0px;

				.list {

					margin: 0px 10px;
					padding: 10px 0px;
					border-bottom: #f0f0f0 1px solid;

					.top {
						display: flex;
						align-items: center;
						margin-bottom: 5px;

						.left {
							margin-right: 10px;

							img {
								width: 120px;
								height: 90px;
								border-radius: 5px;
							}
						}

						.right {
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							padding: 4px 0;
							line-height: 20px;

							.title {
								display: block;
								color: #333;
								font-size: 16px;
								padding: 0;
								margin: 0;
								height: 40px;
								overflow: hidden;
							}

							.info {
								display: flex;
								font-size: 14px;
								color: #636363;
								overflow: hidden;
								
								.level {
									height: 20px;
									margin-right: 10px;
									padding: 2px 7px;
									background: #62a7f9;
									color: #fff;
								}
								.type {
									height: 20px;
									margin-right: 10px;
									padding: 2px 7px;
									background: #62a7f9;
									color: #fff;
									
								}

							}

							.text {
								display: flex;
								align-items: center;
								font-size: 14px;
								color: #636363;
								height: 25px;
							}
						}
					}

					.bottom {
						display: flex;
						justify-content: space-between;
						align-items: center;
						color: #636363;

						.position {
							width: calc(100% - 30px);
							height: 20px;
							font-size: 14px;
							white-space: nowrap;
							text-overflow: ellipsis;
							overflow: hidden;
						}

						.icon {
							width: 30px;
							img {
								width: 25px;
								height: 25px;
							}

							.map {
								padding-right: 10px;
							}
						}
					}
				}

				.emptStyle {
					text-align: center;
					font-size: 18px;
					margin-top: 20px;
				}
			}
		}

		.footer {}
	}
</style>